import { parseAsString, useQueryStates } from 'nuqs';

export const useCommentPageTransitionParamStates = () => {
  return useQueryStates({
    commentId: parseAsString,
  });
};
